import React from 'react';
import Widget from './Widget';
import { WidgetProvider } from './WidgetContext';

const WidgetContainer = ({ widgetId, fullWidth = false }) => (
  <WidgetProvider idWidget={widgetId} id="widetContainer">
    <Widget fullWidth={fullWidth} />
  </WidgetProvider>
);

export default WidgetContainer;
